<app-ng-dynamic-breadcrumb [bgColor]="'#eee'" [fontSize]="'16px'" [fontColor]="'#0275d8'" [lastLinkColor]="'#000'" [symbol]="' | '"></app-ng-dynamic-breadcrumb>